export default "dist/images/85a7b2896acb62be76f3ea7100fe9012.png";